export default {
   // 资讯列表
   getInformationList:{
    method:'get',
    url:'/v1/cms/Information'
  },
  // 新增资讯
  addInformation:{
    method:'post',
    url:'/v1/cms/Information'
  },
  // 获取资讯分类列表
  getInformationCategoryList:{
    method:'get',
    url:'/v1/cms/InformationCategory'
  },
  // 资讯分类级联选择器用的树(专题 url_type=11 选的就是这里的一级分类)
  // addBanner.vue:661 内联硬编码了这个地址, 新页面统一走这里
  getInformationCategorySelect:{
    method:'get',
    url:'/v1/cms/InformationCategorySelect'
  },

  // 获取早报列表
  getMorningPaperList:{
    method:'get',
    url:'/v1/cms/MorningPaper'
  },

}